import React, { Component } from "react";
import { compose } from "recompose";
import PropTypes from "prop-types";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import PlayerRow from "./PlayerRow";

const styles = (theme) => ({
  paperClass: {
    margin: "25px 0",
    padding: "10px 5px",
  },
  smallCell: { padding: 0, width: 55, textAlign: "center" },
  smallCellNumber: { padding: 0, width: 55, textAlign: "center" },
  smallCellMark: { fontSize: 12, padding: 0, width: 35, textAlign: "center" },
  smallCellEnabled: { width: 100, textAlign: "center", padding: 0 },
  table: { overflow: "visible" },
  playerTotal: { color: "#888", fontSize: "0.8em" },
});
class PlayerManagementTable extends Component {
  render() {
    const {
      classes,
      playerData,
      showPassword,
      onPasswordClick,
      menuClick,
      anchorEls,
      handleClick,
      handleClose,
      createPlayerPriv,
    } = this.props;
    return (
      <Paper className={classes.paperClass}>
        <Typography
          className="player-management-table-title"
          align="center"
          variant="display1"
          gutterBottom
        >
          {playerData.agent}{" "}
          <span className={classes.playerTotal}>
            - {playerData.list.length} Player
            {playerData.list.length > 1 ? "s" : null}
          </span>
        </Typography>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell className={classes.smallCell}>Player</TableCell>
              <TableCell className={classes.smallCellEnabled}>
                Enabled
              </TableCell>
              <TableCell className={classes.smallCellNumber}>Max</TableCell>
              <TableCell className={classes.smallCellNumber}>Min</TableCell>
              <TableCell className={classes.smallCellNumber}>
                Credit <br /> Limit
              </TableCell>
              <TableCell className={classes.smallCellMark}>Sport</TableCell>
              <TableCell className={classes.smallCellMark}>
                Virtual Casino
              </TableCell>
              <TableCell className={classes.smallCellMark}>Horse</TableCell>
              <TableCell className={classes.smallCellNumber}>Balance</TableCell>
              <TableCell className={classes.smallCell}>Last Wager</TableCell>
              <TableCell className={classes.smallCell}>Edit</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {playerData.list.map((player, i) => (
              <PlayerRow
                key={`player-row-management-${player.IdPlayer}`}
                {...{
                  i,
                  player,
                  menuClick,
                  createPlayerPriv,
                  anchorEl: anchorEls[player.IdPlayer],
                  handleMenuClick: handleClick,
                  handleMenuClose: handleClose,
                  showPassword,
                  onPasswordClick,
                }}
              />
            ))}
          </TableBody>
        </Table>
      </Paper>
    );
  }
}

PlayerManagementTable.propTypes = {
  theme: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  anchorEls: PropTypes.array.isRequired,
  menuClick: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleClick: PropTypes.func.isRequired,
  playerData: PropTypes.object.isRequired,
  showPassword: PropTypes.bool.isRequired,
  createPlayerPriv: PropTypes.bool.isRequired,
  onPasswordClick: PropTypes.func.isRequired,
};

export default compose(
  withStyles(styles, {
    name: "PlayerManagementTable",
    withTheme: true,
  })
)(PlayerManagementTable);
